const eventsEnum = {
   "layer-add-result": "layer-add-result",
   "layers-add-result": "layers-add-result"
};

module.exports = {
   eventsEnum: eventsEnum
};